// extracted by mini-css-extract-plugin
module.exports = {"cart-item":"CartItem_cart-item__1SK6C","summary":"CartItem_summary__11vnO","price":"CartItem_price__4DSo-","amount":"CartItem_amount__2wYIf","actions":"CartItem_actions__VUmeU"};